import { useEffect, useState } from "react";

interface IsOnlineBadgeProps {
  url: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function IsOnlineBadge({
  url,
  size = "md",
  className,
}: IsOnlineBadgeProps) {
  const [isOnline, setIsOnline] = useState<boolean | null>(null);

  useEffect(() => {
    const checkUrl = async () => {
      try {
        const response = await fetch(url, {
          method: "HEAD",
          mode: "no-cors",
        });
        setIsOnline(true);
      } catch {
        setIsOnline(false);
      }
    };

    checkUrl();
    const interval = setInterval(checkUrl, 30000); // Проверять каждые 30 секунд

    return () => clearInterval(interval);
  }, [url]);

  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  if (isOnline !== false) {
    return null;
  }

  return (
    <div
      className={`${sizeClasses[size]} bg-red-500 rounded-full animate-pulse ${className}`}
    />
  );
}
